var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDictionaries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0965 14.145H7.07983C6.73483 14.145 6.45483 13.865 6.45483 13.52C6.45483 13.175 6.73483 12.895 7.07983 12.895H13.0965C13.4415 12.895 13.7215 13.175 13.7215 13.52C13.7215 13.865 13.4415 14.145 13.0965 14.145Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0965 10.6562H7.07983C6.73483 10.6562 6.45483 10.3762 6.45483 10.0312C6.45483 9.68625 6.73483 9.40625 7.07983 9.40625H13.0965C13.4415 9.40625 13.7215 9.68625 13.7215 10.0312C13.7215 10.3762 13.4415 10.6562 13.0965 10.6562Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37542 7.17529H7.07959C6.73459 7.17529 6.45459 6.89529 6.45459 6.55029C6.45459 6.20529 6.73459 5.92529 7.07959 5.92529H9.37542C9.72042 5.92529 10.0004 6.20529 10.0004 6.55029C10.0004 6.89529 9.72042 7.17529 9.37542 7.17529Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8578_49427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.66699H17.6372V18.2585H2.5V1.66699Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8578_49427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2573 2.91699L6.84976 2.92033C4.90976 2.93199 3.74976 4.13199 3.74976 6.13116V13.7945C3.74976 15.807 4.92059 17.0087 6.87976 17.0087L13.2873 17.0062C15.2273 16.9945 16.3873 15.7928 16.3873 13.7945V6.13116C16.3873 4.11866 15.2173 2.91699 13.2573 2.91699ZM6.88059 18.2587C4.26059 18.2587 2.49976 16.4645 2.49976 13.7945V6.13116C2.49976 3.43699 4.20559 1.68616 6.84559 1.67033L13.2564 1.66699H13.2573C15.8773 1.66699 17.6373 3.46116 17.6373 6.13116V13.7945C17.6373 16.4878 15.9314 18.2395 13.2914 18.2562L6.88059 18.2587Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionaries);
export default __webpack_public_path__ + "static/media/dictionaries.e3a76048f5da8b20bad4b5b27e3247ce.svg";
export { ForwardRef as ReactComponent };